module.exports = __webpack_public_path__ + "img/action_plus.7f084963.svg";